import { getGlobalHeadersAsObject } from "./global-headers";

export type SearchTemplateValue = {
	count: number | "*";
	url: string;
};
export type SearchTemplates = {};

export const getSearchTemplates = (): Promise<SearchTemplates> => {
	return fetch("/api/v2/search_templates/", {
		method: "GET",
		headers: getGlobalHeadersAsObject(),
	}).then((res) => res.json());
};
